module.exports = __webpack_public_path__ + "841639490539025291c0cfa4fbfb78c4.png";